module.exports = __webpack_public_path__ + "img/9788992288156.c4728a79.jpg";